module.exports = __webpack_public_path__ + "static/img/cyhb.dae2879.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/cyhb.jpg
// module id = UaKZ
// module chunks = 9